import React from 'react';
import { useEffect, useState } from 'react';
import axiosClient from '../libs/axiosClient';
import { setToken } from './auth';
import { handleRedirectUrlCheck } from '../common/redirectUrlCheck';
const GOOGLE_CLIENT_ID =
  '509512086607-nupv41m615m03ovgdm31rbka83v6181e.apps.googleusercontent.com';
const GOOGLE_REDIRECT_URI = `${window.location.origin}/auth/google/callback`;
export const GOOGLE_AUTH_URL = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${GOOGLE_CLIENT_ID}&redirect_uri=${GOOGLE_REDIRECT_URI}&scope=email profile&response_type=code`;
function Google() {
  useEffect(() => {
    let params = new URL(document.URL).searchParams;
    let code = params.get('code');

    axiosClient
      .post(
        '/func/user/login/google',
        {
          code: code,
          redirect_uri: GOOGLE_REDIRECT_URI,
        },
        {
          headers: {
            'Access-Control-Allow-Origin': 'https://api.us.ondoc.co.kr',
          },
          withCredentials: true,
        },
      )
      .then((res) => {
        setToken(res.data);
        let rurl = localStorage.getItem('rurl');
        if (handleRedirectUrlCheck(rurl || '/'))
          window.location.href = rurl || '/';
        else window.location.href = '/';
      })
      .catch((err) => {
        alert(err.response.data.detail);
        window.location.href = '/login';
      });
  }, []);
  return <div></div>;
}
export default Google;
